import React from "react";
import {Row} from "antd";
import i18next from "i18next";

class LogoutResultPage extends React.Component {
  constructor(props) {
    super(props);
  }

  UNSAFE_componentWillMount() {
  }

  render() {
    return <Row justify="center" align="middle" style={{height: "100%"}}>
      <div>
        <img src={require("../../assets/images/logout.png")} alt={""} width={80} height={80} />
        <div style={{marginTop: "10%"}}>
          <span style={{fontSize: 14}}>{i18next.t("login:Logged out successfully")}</span>
        </div>
      </div>
    </Row>;
  }
}

export default LogoutResultPage;
